<h2 mat-dialog-title>Wyłączenie autopłatności</h2>
<mat-dialog-content>
  <div>Czy na pewno chcesz wyłączyć autopłatność dla opłaty {{ data.title }}?</div>
</mat-dialog-content>
<mat-dialog-actions align="start">
  <button mat-raised-button color="primary" [matDialogClose]="true">Wyłącz</button>
  <button mat-button matDialogClose>Zamknij</button>
</mat-dialog-actions>
